import AuthGuard from '@components/AuthGuard';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import useInquiryInfo from '@hooks/inquiry/useInquiryInfo';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import BarcodeIcon from '@icons/BarcodeIcon';
import CsIcon from '@icons/CsIcon';
import SettingIcon from '@icons/SettingIcon';
import { Link } from '@router/Link';
import { useFlow } from '@router/stackflow';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useSetAtom } from 'jotai';

import SidebarButton from './SidebarButton';

function SidebarHeader() {
  const { user } = useUser();
  const setSidebar = useSetAtom(isSidebarOpenAtom);
  const closeSidebar = () => setSidebar(false);
  const { push } = useFlow();
  const { inquiryEnabled } = useInquiryInfo();
  return (
        <Container>
            <Row fullWidth justify='space-between' spacing={20}>
                {user ? (
                    <Text fontWeight='bold' size='3xl' css={css`
                    white-space: wrap;
                    word-break: break-all;
                `}>
                        {user?.nickname || '고객'}님
                    </Text>
                ) : (
                    <Link activityName='SignInActivity'
                          activityParams={{}}>
                        <Row>
                            <Text size='3xl' fontWeight='bold'>로그인하기</Text>
                            <ArrowLineRight size={24} color={colors.gray6}/>
                        </Row>
                    </Link>
                )}
                <Text onClick={closeSidebar}>
                    닫기
                </Text>
            </Row>
            <Row spacing={8}>
                <AuthGuard>
                    <SidebarButton label='멤버십 바코드'
                                   icon={BarcodeIcon}
                                   onClick={() => push('BarcodeModal', {})} />
                </AuthGuard>
                {inquiryEnabled && (
                    <AuthGuard>
                        <SidebarButton label='고객센터'
                                       icon={CsIcon}
                                       onClick={() => push('CustomerServiceActivity', { type: 'BRAND' })} />
                    </AuthGuard>
                )}
                <Wrapper>
                    <SidebarButton label='계정설정'
                                   icon={SettingIcon}
                                   onClick={() => push('AccountSettingActivity', {})} />
                </Wrapper>
            </Row>
        </Container>
  );
}

const Container = styled.div`
    padding: calc(64px +  var(--safe-area-top)) 16px 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 32px;
`;

const Wrapper = styled.div`
    width: 100%;
`;

export default SidebarHeader;
